<div class="padding row">
  <div class="col-sm-12 col-md-12" *ngIf="!contracts?.length && !loadingContracts">
    <gp-illustrated-message [width]="'60%'"
                            [type]="'NO_SEARCH_RESULTS'"
                            [text]="'MSS.no_active_contracts_found'">
    </gp-illustrated-message>
  </div>
  <div class="col-sm-12 col-md-7" *ngIf="contracts?.length">
    <div class="box card-box box-shadow">
      <div class="box-header"><h3>{{'MSS.set_new_backup' | translate}}</h3></div>
      <div class="box-body">
        <div [formGroup]="backupForm" class="form-group m-t-md">
          <div class="row">
            <div class="col-md-8 offset-md-2">
              <label test-id="contract-label">{{'FORMS.Contract' | translate}} <span class="required">*</span></label>
              <ng-select class="form-control"
                         formControlName="contractId"
                         ngDefaultControl
                         [attr.test-id]=""
                         [idField]="'value'"
                         [textField]="'display'"
                         [items]="displayContracts">
              </ng-select>
            </div>
          </div>
          <div class="row m-t-md">
            <div class="col-md-8 offset-md-2">
              <label test-id="backup-begin-date-label">{{ 'FORMS.begin_date' | translate }} <span class="required">*</span></label>
              <datepicker-input
                ngDefaultControl
                [dateRangeCorrection]="true"
                formControlName="backupBeginDate">
              </datepicker-input>
            </div>
          </div>
          <div class="row m-t-md">
            <div class="col-md-8 offset-md-2">
              <label test-id="backup-end-date-label">{{ 'FORMS.end_date' | translate }} <span class="required">*</span></label>
              <datepicker-input
                ngDefaultControl
                [dateRangeCorrection]="true"
                formControlName="backupEndDate">
              </datepicker-input>
            </div>
          </div>
          <div class="row m-t-md">
            <div class="col-md-8 offset-md-2">
              <label test-id="backup-employee-label">{{ 'MSS.backup_employee' | translate }} <span class="required">*</span></label>
              <ng-select class="form-control employee"
                         [textField]="'display'"
                         [idField]="'value'"
                         [items]="employees"
                         (typed)="filterEmployee($event)"
                         ngDefaultControl
                         formControlName="backupEmployeeId"
                         [asyncAutoCompletion]="true"
              ></ng-select>
            </div>
          </div>
          <div class="row m-t-md">
            <div class="col-md-8 offset-md-2">
              <ul *ngIf="backupForm?.errors; let errors"
                  test-id="error-list" class="error-list">
                <li *ngIf="errors.beginDateAfterEndDate">
                  {{ 'MSS.begin_date_after_end_date' | translate }}
                </li>
                <li *ngIf="errors.beginDateBeforeContractStart">
                  {{ 'MSS.begin_date_before_contract_start' | translate }}
                </li>
                <li *ngIf="errors.beginDateAfterEndOfContract">
                  {{ 'MSS.begin_date_after_end_contract' | translate }}
                </li>
                <li *ngIf="errors.endDateAfterContractEnd">
                  {{ 'MSS.end_date_after_end_contract' | translate }}
                </li>
                <li *ngIf="errors.endDateBeforeToday">
                  {{ 'MSS.end_date_before_today' | translate }}
                </li>
                <li *ngIf="errors.endDateBeforeContractStart">
                  {{ 'MSS.end_date_before_contract_start' | translate }}
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="box-footer flex-end">
        <div class="btn-bar">
          <button type="button"
                  test-id="cancel-backup-form"
                  class="btn dark-white p-x-md"
                  (click)="clearBackupForm()">
            {{ 'FORMS.cancel' | translate }}
          </button>
          <button class="btn primary p-x-md"
                  test-id="add-backup"
                  (click)="addBackup()"
                  [disabled]="!backupForm?.valid">
            {{ 'FORMS.save' | translate }}
          </button>
        </div>
      </div>
    </div>
  </div>
  <div class="col-sm-12 col-md-5" *ngIf="contracts?.length">
    <div class="box card-box box-shadow">
      <div class="box-header"><h3>{{'MSS.my_backup' | translate}}</h3></div>
      <div class="box-body light">
        <ng-container *ngIf="!loading && backups?.length">
          <ul class="timeline default-cursor">
            <li class="tl-item backup-card" *ngFor="let backup of backups">
              <div class="tl-wrap">
                <span class="tl-date">
                  <span class="label rounded text-white m-r-sm"
                        test-id="backup-begin-date">{{backup.backupBeginDate | gpDate}}</span>
                  <i class="fa-light fa-arrow-right" aria-hidden="true"></i>
                  <span class="label rounded text-white m-l-sm"
                        test-id="backup-end-date">{{backup.backupEndDate | gpDate}}</span>
                </span>
                <div class="tl-content box-color text-color w-full m-t-lg">
                  <span class="arrow b-white left pull-top"></span>
                  <div class="text-lt p-x m-b-sm">
                    <h3 class="text-ellipsis" test-id="backup-position-name">{{backup.position.name}}
                      <button class="btn btn-sm btn-icon pull-right"
                              [tooltip]="'MSS.delete_backup' | translate"
                              container="body"
                              test-id="delete-backup"
                              (click)="deleteBackup(backup)">
                        <span class="fa-light fa-trash-can"></span>
                      </button>
                    </h3>
                    <small class="text-muted">
                      <strong test-id="backup-cliReg-name">{{backup.contract.cliRegNickName}}</strong>
                      <ng-container *ngIf="backup.contract.contractNumber">&nbsp;|&nbsp;{{backup.contract.contractNumber}}</ng-container>
                      &nbsp;|&nbsp;{{
                      backup.contract.beginDate | gpDate
                      }} - {{
                      backup.contract.endDate | gpDate
                      }}
                    </small>

                  </div>
                  <div class="p-a b-t b-slate-gray-20 flex flex-between">
                    <gp-user-avatar [pictureUri]="backup?.backupEmployee?.photoUuid"
                                    [initials]="(backup?.backupEmployee?.firstName?.charAt(0) || '') + (backup?.backupEmployee?.lastName?.charAt(0) || '')"
                                    [backup]="true"
                                    size="lg">
                    </gp-user-avatar>
                    <div class="backup-employee flex-1 m-l-sm">

                      <h4 class="text-ellipsis">{{backup.backupEmployee.firstName + ' ' + backup.backupEmployee.lastName}}</h4>
                      <div *ngIf="backup.backupEmployee.intFirstName && backup.backupEmployee.intLastName">
                        ({{backup.backupEmployee.intFirstName + ' ' + backup.backupEmployee.intLastName}})
                      </div>
                      <div class="text-muted">
                        {{backup.backupEmployee.employeeNumber}}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </ng-container>
        <div *ngIf="!loading && !backups?.length">
          <gp-illustrated-message
            [width]="'60%'"
            [type]="'NO_CONTENT'"
            [text]="'MSS.no_backup_set'">
          </gp-illustrated-message>
        </div>
      </div>
    </div>
  </div>
</div>
